import React from 'react';
import HBPopover from '../HBPopover/HBPopover';
import { IPopoverProps } from '../HBPopover/HBPopover';
import { THBCalloutPopoverTheme } from './HBCalloutPopover.types';
import { getCalloutPopoverStyles } from './HBCalloutPopover.styles';
import { MustIncludeOneOfBasicTestIdProps } from '../common/internal/test-id.types';
import HBCalloutPopoverContent, {
    ICalloutPopoverContentProps
} from './HBCalloutPopoverContent/HBCalloutPopoverContent';
type ICalloutPopoverBasicProps = Omit<
    IPopoverProps,
    'customStyle' | 'theme' | 'actionsAlignment' | 'children' | 'actions'
>;

export type ICalloutPopoverProps = ICalloutPopoverContentProps &
    ICalloutPopoverBasicProps;

const HBCalloutPopover = ({
    openTrigger = 'click',
    title,
    description,
    calloutTheme = 'neutral',
    primaryActionType = 'button',
    actions,
    mediaPath,
    testId,
    testIdName,
    onClose,
    withIcon = true,
    stepsContent,
    ...popoverProps
}: ICalloutPopoverProps & MustIncludeOneOfBasicTestIdProps) => {
    const styles: THBCalloutPopoverTheme =
        getCalloutPopoverStyles()[calloutTheme];

    return (
        <HBPopover
            testId={testId}
            testIdName={testIdName}
            // if the dismiss button shows, its the only way to close the popover
            shouldSupportClickOutside={!onClose}
            customStyle={styles}
            openTrigger={openTrigger || 'hover'}
            theme={styles.theme}
            actionsAlignment="right"
            {...popoverProps}
        >
            <HBCalloutPopoverContent
                title={title}
                description={description}
                calloutTheme={calloutTheme}
                primaryActionType={primaryActionType}
                mediaPath={mediaPath}
                actions={actions}
                onClose={onClose}
                testId={testId}
                testIdName={testIdName}
                withIcon={withIcon}
                stepsContent={stepsContent}
            />
        </HBPopover>
    );
};

export default HBCalloutPopover;
